var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c(
        "job-preview-content-outline",
        _vm._g(
          {
            attrs: {
              title: "選考プロセス",
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.selection.process
              ),
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "text-counts": [
                _vm.getTextCount(
                  "選考プロセス",
                  _vm.selection.selectionProcess,
                  _vm.targetIdMap.selection.process
                ),
              ],
              "target-id": _vm.targetIdMap.selection.process,
              value: _vm.selection.selectionProcess,
              "data-test": "process",
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm._l([1, 2, 3], function (index) {
        return [
          _vm.isShow.interview(index)
            ? _c(
                "job-preview-content-interview",
                _vm._g(
                  {
                    key: "interview-" + index,
                    attrs: {
                      index: index,
                      zip: _vm.selection["zipCode" + index],
                      address: _vm.selection["address" + index],
                      person: _vm.selection["personInCharge" + index],
                      tel: _vm.selection["tel" + index],
                      map: _vm.selection["placeMapAddress" + index],
                      "comment-highlights": _vm.getAnyCommentHighlights(
                        _vm.targetIdMap.selection.interview.prefix,
                        index
                      ),
                      "highlight-mode": _vm.highlightMode,
                      "text-count-mode": _vm.textCountMode,
                      "data-test": "interview-" + index,
                    },
                  },
                  _vm.$listeners
                )
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c(
        "job-preview-content-inquiry",
        _vm._g(
          {
            attrs: {
              "company-name": _vm.companyName,
              url: _vm.selection.inquiryUrl,
              zip: _vm.selection.inquiryZip,
              address: _vm.selection.inquiryAddress,
              person: _vm.selection.inquiryPerson,
              tel: _vm.selection.inquiryTel,
              email: _vm.selection.inquiryEmail,
              "comment-highlights": _vm.getAnyCommentHighlights(
                _vm.targetIdMap.selection.inquiry.prefix
              ),
              "highlight-mode": _vm.highlightMode,
              "text-count-mode": _vm.textCountMode,
              "data-test": "inquiry",
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _vm.isShow.links
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              { attrs: { title: "関連リンク", "data-test": "links" } },
              _vm.$listeners
            ),
            [
              _c(
                "job-preview-content",
                _vm._g(
                  {
                    attrs: {
                      "comment-highlights": _vm.getAnyCommentHighlights(
                        _vm.targetIdMap.selection.link
                      ),
                      "highlight-mode": _vm.highlightMode,
                      "data-test": "links-content",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c(
                                "p",
                                { staticClass: "clearfix" },
                                [
                                  _vm._l([1, 2, 3], function (index) {
                                    return [
                                      _vm.selection["companyLinkNm" + index]
                                        ? [
                                            _c(_vm.tag, {
                                              key: "link-" + index,
                                              tag: "component",
                                              class: {
                                                "text-underline":
                                                  _vm.highlightMode,
                                              },
                                              attrs: {
                                                id:
                                                  _vm.targetIdMap.selection
                                                    .link +
                                                  "-" +
                                                  index,
                                                href: _vm.selection[
                                                  "companyLinkUrl" + index
                                                ],
                                                rel: "nofollow",
                                                target: "_blank",
                                                "data-test": "link-" + index,
                                              },
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.selection[
                                                    "companyLinkNm" + index
                                                  ]
                                                ),
                                              },
                                            }),
                                            _c("br", {
                                              key: "link-br-" + index,
                                            }),
                                          ]
                                        : _vm._e(),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2431137983
                    ),
                  },
                  _vm.$listeners
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }